// src/Components/ReportCard.js
import React, { useState } from 'react';
import { IconContext } from 'react-icons';
import Popup from './Popup';
import { useNavigate } from 'react-router-dom';
import './styles/reportcard.css';

function ReportCard({ icon: Icon, iconColor, title, description, iconBgColor, popupContent, viewType, viewMorePath }) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const navigate = useNavigate();

    const handleViewMore = (event) => {
        event.preventDefault();

        if (viewType === 'popup') {
            setIsPopupOpen(true);
        } else if (viewType === 'page') {
            navigate(viewMorePath);
        }
    };

    const isUnavailable = viewType === 'popup' && !popupContent;

    return (
        <article className="report-card" style={{ '--report-accent': iconColor }}>
            <IconContext.Provider value={{ color: iconColor, size: "3em" }}>
                <div className='reportcard-div' style={{ backgroundColor: iconBgColor }}>
                    <Icon className='reportcard-icon' />
                </div>
            </IconContext.Provider>

            <div className="report-card-content">
                <h3>{title}</h3>
                <p>{description}</p>
                <button
                    type="button"
                    className="view-more"
                    onClick={handleViewMore}
                    disabled={isUnavailable}
                >
                    {isUnavailable ? 'Coming soon' : 'Generate'}
                </button>
            </div>

            {viewType === 'popup' && (
                <Popup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} title={title}>
                    {React.isValidElement(popupContent)
                        ? React.cloneElement(popupContent, { onCancel: () => setIsPopupOpen(false) })
                        : popupContent}
                </Popup>
            )}
        </article>
    );
}

export default ReportCard;
